import { useQuery } from '@tanstack/react-query';
import type { ErpErrorLogToken } from '@sleed/bizcommerce-api';
import { reportsApi } from '~/lib/api/client';

export const erpLogsKeys = {
	all: ['erp-logs'] as const,
	list: (limit: number) => [...erpLogsKeys.all, 'list', limit] as const
};

/** ERP error/fatal log rows from SigNoz telemetry (`ReportsApi.getErpErrorLogs`), newest first. */
export function useErpLogs(limit = 200) {
	return useQuery<ErpErrorLogToken[]>({
		queryKey: erpLogsKeys.list(limit),
		queryFn: async () => (await reportsApi.getErpErrorLogs(limit)).data.items ?? [],
		staleTime: 60_000
	});
}
